module.exports = __webpack_public_path__ + "img/图片5.70a3b149.png";